import { Injectable } from '@angular/core';
import { AuthService } from '#services/shared';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from '@angular/router';
import { Role } from 'models/enum/role';
import { Utility } from '#services/shared/utility';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (!this.authService.isAuthenticated()) {
      // user not authenticated
      this.router.navigate(['/login']);
      return false;
    }
    const roles = route.data.roles as Role[];
    if (!roles) {
      throw new Error('Property roles is missing');
    }

    const usr = this.authService.getCurrentUser();

    if (!Utility.isValidObj(usr)) {
      // User object is invalid, treat as session expired
      this.router.navigate(['/login']);
      return false;
    }

    if (!Utility.isTrue(usr.HasAccess)) {
      // User is authenticated but does not have access
      localStorage.removeItem('localUserReg');
      localStorage.setItem('localUserReg', JSON.stringify(usr));

      // localStorage.clear();
      this.router.navigate(['/error/not-registered']);
      return false;

    }

    if (!roles.some((role) => this.authService.hasRole(role))) {
      this.router.navigate(['/error/not-authorized']);
      return false;
    }

    return true;
  }
}
